import { ChangeDetectionStrategy, Component, input, linkedSignal } from '@angular/core';
import { IsoDate, QueryFilter, Range, uuid } from '@softline/core';
import { FilterInputBase } from '../filter-input.base';
import { FilterItemConfig } from '../../../../types/filter-config';
import { Filter } from '../../../../types/filter';
import { DateFilterOperator } from '../../../../types/filter-operators';
import { PageFilterDataService } from '../../../services/data-source/page-filter-data.service';
import { FilterValueInputComponent } from '../../page-filter/page-filter-custom/filter-value-input/filter-value-input.component';

/** Editor for a single date or a between range; reuses the custom tab's value input. */
@Component({
  selector: 'soft-date-filter-input',
  imports: [FilterValueInputComponent],
  templateUrl: './date-filter-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateFilterInputComponent<T extends object> extends FilterInputBase<T, DateFilterOperator> {
  override readonly item = input.required<FilterItemConfig<T>>();
  override readonly itemFilter = input.required<(Filter<T> & { operator: DateFilterOperator }) | null>();
  override readonly operator = input.required<DateFilterOperator>();
  override readonly dataService = input.required<PageFilterDataService<T>>();
  override readonly queryFilter = input.required<QueryFilter<T> | null>();

  readonly draft = linkedSignal<unknown>(
    () => (this.itemFilter() as { value?: unknown } | null)?.value ?? null
  );

  getFilterValue(): Filter<T> | null {
    const operator = this.operator();
    const value = this.draft();
    if (operator === 'between') {
      const range = value as Partial<Range<IsoDate>> | null;
      if (!range?.from || !range?.to) return null;
    } else if (value === null || value === undefined || value === '') {
      return null;
    }
    const current = this.itemFilter() as (Filter<T> & { reference?: Range<IsoDate> }) | null;
    const node = {
      uuid: current?.uuid ?? uuid(),
      type: this.item().type,
      field: this.item().field,
      operator,
      value,
    } as Filter<T> & { reference?: Range<IsoDate> };
    // an edit of the period keeps a comparison the reference item put there
    if (operator === 'between' && current?.reference) node.reference = current.reference;
    return node;
  }
}
